export default "__VITE_ASSET__Bk7itU$w__"